var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    viewBox: "0 0 66 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_6206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4462 40.2106C26.3497 40.2456 23.283 39.6037 20.4604 38.3298C17.5736 37.0362 14.891 35.3281 12.4975 33.2596C9.65266 30.9112 7.18905 28.1359 5.1945 25.0327C4.83155 24.4607 4.55659 23.8338 4.23764 23.2289C4.06587 22.8685 3.98502 22.4715 4.00228 22.0727C4.01954 21.6739 4.13433 21.2854 4.33659 20.9412C5.4603 18.7446 6.88561 16.7159 8.57105 14.914C10.859 12.2902 13.5022 9.9987 16.4239 8.10594C19.1014 6.33269 22.0849 5.07217 25.2227 4.38847C28.3033 3.75721 31.492 3.89699 34.5055 4.79541C38.6442 6.07735 42.4589 8.23414 45.691 11.1195C48.3366 13.3365 50.6416 15.9306 52.5321 18.8185C53.0118 19.5704 53.4346 20.3571 53.7969 21.1722C53.9718 21.6473 54.035 22.1564 53.9816 22.6599C53.9282 23.1634 53.7596 23.6479 53.4889 24.0758C52.412 26.141 51.0495 28.0441 49.4415 29.729C46.471 33.027 42.9177 35.7488 38.9599 37.7579C36.0116 39.2756 32.7608 40.1136 29.4462 40.2106ZM28.9953 8.98584C26.3573 8.98944 23.7816 9.78809 21.6044 11.2776C19.4272 12.7671 17.7495 14.8783 16.7902 17.3357C15.8309 19.7931 15.6347 22.4826 16.227 25.0532C16.8193 27.6238 18.1727 29.9563 20.1106 31.7461C22.0485 33.5359 24.4809 34.7001 27.0904 35.0866C29.6999 35.4732 32.3654 35.0642 34.739 33.9131C37.1125 32.7619 39.084 30.922 40.3961 28.6335C41.7082 26.345 42.3001 23.7142 42.0945 21.0842C41.8418 17.7864 40.3509 14.7062 37.9212 12.4621C35.4914 10.218 32.3028 8.97617 28.9953 8.98584Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3741 19.0384L28.9732 22.129L26.4985 15.233C27.9739 14.6662 29.5946 14.6004 31.111 15.0456C32.6275 15.4908 33.9555 16.4223 34.8904 17.6966C35.9488 19.1528 36.4358 20.9468 36.2589 22.7383C36.0821 24.5298 35.2536 26.194 33.9308 27.415C32.608 28.6361 30.8829 29.3289 29.0831 29.3622C27.2832 29.3954 25.5338 28.7666 24.1668 27.5953C22.9649 26.5673 22.1371 25.1702 21.8128 23.6222C21.4885 22.0743 21.6859 20.4624 22.3741 19.0384Z",
    fill: "#FA3676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_6206",
    x: 0,
    y: 0,
    width: 66,
    height: 52.2119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_6206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_6206",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.2926ca6d2b56dc54d9959f81b2ae3784.svg";
export { ForwardRef as ReactComponent };